import { Model } from 'algu-domain'

import { configuratorInterface } from '../configurator-interface.js'
import { ALL_VIOLATIONS } from './all-violations.js'

/**
 * A user should always be able to select a Fenix variant for their table top. This transformer
 * adjusts all other attributes automatically when changing material.
 */
export const fixTableTopFenixVariantUpdateTransformer = configuratorInterface.transformerBuilder.when
  .entity(Model.Top.types)
  .modified({ atFields: ['fenixVariant'] })
  .causes.entity(Model.AnyDomainEntity.types)
  .violation(ALL_VIOLATIONS)
  .then.overrideMatchingUpdate(ctx => {
    const $topEntity = ctx.getNew$Entity()
    const thickness = $topEntity.$availableThicknesses.includes($topEntity.thickness)
      ? $topEntity.thickness
      : $topEntity.$availableThicknesses.at(0)

    if (Model.TopCircle.is($topEntity)) {
      // Round tables have different sets of diameters for different types of material
      const { diameter, $availableDiameters } = $topEntity
      const newDiameter = $availableDiameters.includes(diameter)
        ? diameter
        : $availableDiameters.reduce((acc, val) => {
            return Math.abs(val - diameter) < Math.abs(acc - diameter) ? val : acc
          }, 0)
      const fixTopCircleUpdate = configuratorInterface.updates.DomainEntityModification({
        entityId: $topEntity.id,
        stateDelta: {
          color: $topEntity.color,
          edgeFinish: $topEntity.edgeFinish,
          diameter: newDiameter,
          fenixVariant: $topEntity.fenixVariant,
          material: $topEntity.material,
          thickness,
          topFinish: $topEntity.topFinish,
        },
        updateTag: 'fixTopCircle.updateFenixVariant',
      })
      return [fixTopCircleUpdate]
    }

    const fixTopWithLengthAndWidthUpdate = configuratorInterface.updates.DomainEntityModification({
      entityId: $topEntity.id,
      stateDelta: {
        color: $topEntity.color,
        edgeFinish: $topEntity.edgeFinish,
        fenixVariant: $topEntity.fenixVariant,
        material: $topEntity.material,
        thickness,
        topFinish: $topEntity.topFinish,
      },
      updateTag: 'fixTableTop.updateFenixVariant',
    })

    return [fixTopWithLengthAndWidthUpdate]
  })
  .build('Fix table top fenix variant update transformer')
